import React from 'react';
import FilterInputField from '../../../components/TableFilter/ColumnsFilters/FilterInputField';
import ColumnSorting from '../../../components/TableFilter/ColumnsFilters/ColumnSorting';
import { capitalize } from 'lodash';
import FilterTreeSelect from '../../../components/TableFilter/ColumnsFilters/FilterTreeSelect/FilterTreeSelect';

export const parentOrganizationsColumns = (t, lang) => {
  return [
    {
      Header: <ColumnSorting title={t('serviceProviders_columnId')} name="id" />,
      accessor: 'id',
      resize: false,
      maxWidth: 250,
      Filter: <FilterInputField name="id" type="number" />
    },
    {
      Header: <ColumnSorting title={t('serviceProviders_columnBin')} name="bin" />,
      accessor: 'bin',
      maxWidth: 250,
      Filter: <FilterInputField name="bin" type="text" />
    },
    {
      Header: (
        <ColumnSorting title={t('serviceProviders_columnName')} name={`${lang}Name`} />
      ),
      maxWidth: 250,
      accessor: `${lang}_name`,
      Cell: ({ original }) => original[`${lang}_name`],
      Filter: <FilterInputField name={`name${capitalize(lang)}`} type="text" />
    },
    {
      Header: <ColumnSorting title={t('serviceProviders_columnIin')} name="iin" />,
      accessor: 'iin',
      maxWidth: 250,
      Filter: <FilterInputField name="iin" type="number" />
    },
    {
      Header: (
        <ColumnSorting title={t('serviceProviders_columnLocation')} name="location" />
      ),
      accessor: 'location',
      maxWidth: 250,
      Cell: ({ original }) => original.providerLocation ? original.providerLocation[`${lang}_name`] : '',
      Filter: <FilterTreeSelect lookupId="60" name="location" lang={lang} />
    }
  ];
};
